module.exports = __webpack_public_path__ + "img/icon-progress.cb0a2c4a.svg";